<app-smart-assistant-gif-container [showBackBtn]="true" [subTitle]="operateTitle"
    (back)="back()" [gifTips]="str.gifTips" imagePrefix="carousel">
</app-smart-assistant-gif-container>

<!-- 发放引导 -->
<div>
    <!-- 文字提示 -->
    <h1 class="mb-10">{{i18n.provisioningGuidance}}</h1>
    <span class="sub">{{i18n.provisioningTip1}}</span>
    <!-- 了解更多 -->
    <a *ngIf="!str.isOem" [href]="i18n.ultraPathUrl" target="_blank" class="know-more"> {{i18n.knowMoreBtn}}</a>
    <div class="mt-15 mb-15 sub">{{i18n.provisioningTip2}}</div>
</div>

<!-- 引导步骤 -->
<app-storage-resources-guidance-steps></app-storage-resources-guidance-steps>
